'use es6';

import { handleActions } from 'flux-actions';
import { AccountsActionTypes } from '../actions';
import { Map as ImmutableMap } from 'immutable';
const initialState = ImmutableMap({
  filter: '',
  hubsFailedToLoad: false
});
export default handleActions({
  [AccountsActionTypes.FILTER_ACCOUNTS](state, action) {
    return state.set('filter', action.payload.filter);
  }

}, initialState);